import React from "react";

import BrowserRoute from "./BrowserRoute";

interface IndexRouteProps {
}

const IndexRoute: React.FC<IndexRouteProps> = ({
}) => {
  return (
    <React.Fragment>
       <BrowserRoute />
    </React.Fragment>
  );
};

export default IndexRoute;
